import ApiServer from '@/utils/api/ApiServer.js'

const fetchTractInstructions = async (_, tractId) => {
  const path = `tracts/${tractId}/instructions`
  const response = await ApiServer.get(path)
  return response.data || null
}

const createTractInstructions = async (_, { tractId, instructions }) => {
  const path = `tracts/${tractId}/instructions`
  const response = await ApiServer.post(path, instructions)
  return response.data
}

const updateTractInstructions = async (_, { tractId, instructions }) => {
  const path = `tracts/${tractId}/instructions`
  await ApiServer.put(path, instructions)
}

const deleteTractInstructions = async (_, tractId) => {
  const path = `tracts/${tractId}/instructions`
  await ApiServer.delete(path)
}

export default {
  fetchTractInstructions,
  createTractInstructions,
  updateTractInstructions,
  deleteTractInstructions
}
